"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body2: function() {
        return _Body2.Body2;
    },
    body2ClassNames: function() {
        return _useBody2Stylesstyles.body2ClassNames;
    }
});
const _Body2 = require("./Body2");
const _useBody2Stylesstyles = require("./useBody2Styles.styles");
